historicData2.forEach(function(q){
  q.Month = q.Date.split("/")[0];
  q.Day = q.Date.split("/")[1];
  q.Year = ("19" + q.Date.split("/")[2]) * 1;
  var matcher = /^([\d.]+) km (.*)$/;
  var result = q.Location.match(matcher);
  if (result) {
    var mi = Math.round(result[1] * 6.21371)/10;
    q.Location = `${mi} mi ${result[2]}`;
  }
})

recentData.forEach(function(q){
  var matcher = /^.*?\(\s*([^)]+)\)\s+(\w+).*?from (.*)$/;
  var result = q.Location.match(matcher);
  if (result) var [_, distance, direction, city] = result;
  q.Location = `${distance} ${direction} of ${city}`;
});

var quakeData = historicData1.concat(historicData2).concat(recentData).map(function(q){
  q.timestamp = q.Year + (q.Month - 1) / 12;
  return q;
});

module.exports = quakeData;